import { EMPTY_STRING } from "../../../constants";
import CustomTooltip from "../toolTipComponent/CustomTooltip";

const TableCustomHeader = ({
  id,
  label,
  toolTipText,
  className = EMPTY_STRING,
}) => {
  const LabelComponent = () => (
    <div className="text-truncate w-auto" id={id}>
      {label}
    </div>
  );

  return (
    <>
      {toolTipText ? (
        <>
          <CustomTooltip
            className={`tooltip-for-text ${className}`}
            anchorSelect={`#${id}`}
          >
            {toolTipText}
          </CustomTooltip>
          <LabelComponent />
        </>
      ) : label ? (
        <LabelComponent />
      ) : (
        EMPTY_STRING
      )}
    </>
  );
};

export default TableCustomHeader;
